export type PublicLocale = "nl" | "fr" | "en" | "de";
export type Locale = "nl-BE" | "fr-BE" | "en-BE" | "fr-LU" | "de-LU" | "en-LU";

export const BE_LOCALES: Locale[] = ["nl-BE", "fr-BE", "en-BE"];
export const LU_LOCALES: Locale[] = ["fr-LU", "de-LU", "en-LU"];
export const LOCALES: Locale[] = [...BE_LOCALES, ...LU_LOCALES];
export const DEFAULT_LOCALE: Locale = "nl-BE";

export const getPublicLocale = (locale: Locale): PublicLocale =>
  locale.split("-")[0] as PublicLocale;

const domainToUrl = (domain: string) =>
  domain.includes(".local") ? `http://${domain}` : `https://${domain}`;

const BE_URL = domainToUrl(process.env.NEXT_PUBLIC_BE_DOMAIN ?? "www.pia.be");
const LU_URL = domainToUrl(process.env.NEXT_PUBLIC_LU_DOMAIN ?? "www.piagroup.lu");

export const getSiteUrlForLocale = (locale?: Locale): string =>
  locale?.endsWith("-LU") ? LU_URL : BE_URL;
